<template>
  <ContentPage back>

    <template #header>
      <ContentPageTitle class="my-n1">Redeem</ContentPageTitle>
    </template>

    <Section>
      <v-form ref="form" @submit.prevent="onSubmit" v-model="isValid">
        <div class="d-flex flex-column align-center">
          <div class="black--text" style="font-size: 20px">
            Available Rewards: {{ $formatters.formatCurrency(me.reward_balance_cents) }}
          </div>

          <img class="mt-4" :src="currentBrand.image_url" width="225px"/>


          <v-select
            outlined dense
            label="Reward Amount"
            class="mt-4" style="max-width: 50%"
            v-model="rewardChoice"
            :items="currentBrand.choices"
            :item-text="i => $formatters.formatCurrency(i.face_value_cents)"
            :item-value="i => i"
            :rules="[ sufficientRewards ]"
          />

          <div v-html="currentBrand.description" class="mx-3" style="font-size: 12px; line-height: 12px;"></div>

          <v-divider />

          <div>
            <v-btn @click="$router.back()">Back</v-btn>
            <RewardConfirmDialog 
              class="ml-3"
              :disabled="!(isValid || loading)"
              @confirm="onSubmit"
            >
              Yes, I want to redeem my {{ $formatters.formatCurrency(rewardChoice.face_value_cents) }}
              <span class="font-weight-bold" style="color: #004056; white-space: nowrap;">
                {{ currentBrand.brand_name}}
              </span> card now
            </RewardConfirmDialog>
          </div>

          <div class="mt-4" style="font-size: 12px;" v-if="currentBrand.always_disclaim">
            The following <OtherTextDialog linkText="disclaimer" :body="currentBrand.disclaimer" /> applies. 
          </div>
        </div>
      </v-form>
    </Section>

    <ErrorOverlay title="Problem Redeeming" v-model="error_dialog" :loading="loading" >
      {{ error_message }}
    </ErrorOverlay>
  </ContentPage>
</template>

<script>

import { ContentPage, ContentPageTitle, Section } from '@/components/pages'
import OtherTextDialog from '../../OtherTextDialog';
import RewardConfirmDialog from './RewardConfirmDialog';

import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RedeemCardView',

  mixins: [ ErrorOverlayMixin ],

  components: { ContentPage, ContentPageTitle, OtherTextDialog, RewardConfirmDialog, Section },

  props: ['brand_key'],

  data: () => ({
    isValid: true,
    rewardChoice: '',
  }),

  computed: {
    ...mapGetters('auth', ['me']),
    ...mapGetters('rewards', ['currentBrand']),

    sufficientRewards() {
      return v => v.face_value_cents < this.me.reward_balance_cents  || 'Insuffient Balance'
    },
  },

  methods: {
    ...mapActions('rewards', ['loadCurrentBrand', 'redeem']),

    async onSubmit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        const { brand_key } = this.currentBrand
        const { face_value_cents, utid } = this.rewardChoice

        const result = await this.redeem({ brand_key, face_value_cents, utid })

        this.loading = false

        if (result.ok) {
          const { redemption_id } = result.inserted
          this.$router.replace({ name: 'reward', params: { redemption_id } })
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      }
    }
  },

  created() {
    this.loadCurrentBrand(this.brand_key)
  },
}
</script>